import React from 'react'
import PropTypes from 'prop-types'
import Pagination from 'components/pagination'
import styles from './styles.module.scss'

const StyledPagination = ({
  pageCount,
  name,
  className,
  onChange,
  forcePage,
}) => (
  <Pagination
    className={`${styles.pagination} ${className}`}
    pageCount={pageCount}
    name={name}
    onChange={onChange}
    scrollToTop={false}
    nextLabel={<i className="cred-icon icon-chevron-right" />}
    previousLabel={<i className="cred-icon icon-chevron-left" />}
    forcePage={forcePage}
  />
)

StyledPagination.propTypes = {
  pageCount: PropTypes.number,
  name: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
  forcePage: PropTypes.number,
}

StyledPagination.defaultProps = {
  className: '',
  onChange: () => {},
}

export default StyledPagination
